import { render, staticRenderFns } from "./editModel.vue?vue&type=template&id=c2819d2a&scoped=true"
import script from "./editModel.vue?vue&type=script&lang=js"
export * from "./editModel.vue?vue&type=script&lang=js"
import style0 from "./editModel.vue?vue&type=style&index=0&id=c2819d2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2819d2a",
  null
  
)

export default component.exports